import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import PillarArticles from './components/PillarArticles';
import FaqFinalSection from './components/FaqFinalSection';
import {
  WhatIsSection,
  FeaturesSection,
  GuidesSection,
  WhySection,
  CompareSafetySection,
} from './components/ContentSections';
import JsonLd from '@/seo/JsonLd';
import { SITE_URL, SITE_NAME, FAVICON_URL, SITE_DESCRIPTION } from '@/seo/schema';

const organizationLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: SITE_URL,
  logo: FAVICON_URL,
  description: SITE_DESCRIPTION,
};

const websiteLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: SITE_URL,
  description: SITE_DESCRIPTION,
  inLanguage: 'en',
  publisher: { '@type': 'Organization', name: SITE_NAME, url: SITE_URL },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={organizationLd} />
      <JsonLd data={websiteLd} />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <WhatIsSection />
        <FeaturesSection />
        <GuidesSection />
        <WhySection />
        <CompareSafetySection />
        <ArticleSection />
        <PillarArticles />
        <FaqFinalSection />
      </main>
      <Footer />
    </div>
  );
}